import { useState } from "react";
import { fetchShuffleBooking } from "../api/api";
import {ShuffleBookingPayload, ShuffleBookingResponse} from "../types";

export function useShuffleBooking() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [result, setResult] = useState<ShuffleBookingResponse | null>(null);

    const bookShuffle = async (payload: ShuffleBookingPayload): Promise<ShuffleBookingResponse | null> => {
        setLoading(true);
        setError(null);
        setResult(null);
        try {
            const data = await fetchShuffleBooking(payload);
            setResult(data);
            return data;
        } catch (err: any) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Unknown error"
            );
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        result,
        bookShuffle,
    };
}
